import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['all', 'item']

  toggleAll() {
    this.itemTargets.forEach((item) => { item.checked = this.allTarget.checked })
  }

  toggleItem() {
    const checkedCount = this.itemTargets.filter((item) => item.checked).length
    this.allTarget.checked = checkedCount === this.itemTargets.length
    this.allTarget.indeterminate = checkedCount > 0 && checkedCount < this.itemTargets.length
  }
}
